import request from "@/utils/request";

export default function readMessage(fromType,fromId) {
    return request({
        url: "/chatLog/readMessage/"+fromType+'/'+fromId,
        method: 'get',
    })
}